import * as NodeListActions from '~app/actions/nodeList';
import * as NodeActions from '~app/actions/node';
import createReducer from '~app/core/createReducer';
import node from './node';
import {arrayMove} from 'react-sortable-hoc';

const initialState = {
  header: {
    title: '',
    description: '',
    images: [null, null],
  },
  nodes:[],
  selected:{},
};

function addNode(state, action) {
  action.type = NodeActions.CREATE_NODE;
  return {
    ...state,
    nodes:[...state.nodes, node(undefined, action)],
  };
}

function updateNode(state, action){
  action.type = NodeActions.UPDATE_NODE;
  return {
    ...state,
    nodes: state.nodes.map(n => node(n, action)),
  };
}

function removeNode(state, {id}) {
  // Get the index of the node associated with the id
  let index = state.nodes.findIndex(x => x.id === id);
  // Remove it from the array
  let nodes = [...state.nodes];
  nodes.splice(index, 1);

  return {
    ...state,
    selected:{},
    nodes:nodes,
  };
}

function sortNode(state, {oldIndex, newIndex}) {
  let nodes =  arrayMove(state.nodes, oldIndex, newIndex);
  return {
    ...state,
    nodes:nodes,
  };
}

function selectNode(state, {id, buttonId, title, className}) {
  // Need to do something with the selected id and buttonId
  // Need to convert state to an array and object?

  return {
    ...state,
    selected:{
      id: id,
      buttonId: buttonId,
      title: title,
      className: className,
    },
  };
}

function unselectNodes(state) {
  return {
    ...state,
    selected: {},
  };
}

function clearNodes(state) {
  return {
    ...state,
    selected:{},
    nodes:[],
  };
}

function loadNodes(state, {nodes}) {
  return {
    ...state,
    nodes,
  };
}

function updateImage(state, {payload}) {
  /* Get node by id, and update node.image at specific index
  * if no url is included in the payload, image will be
  * reset to null. Therefore images are only updated,
  * not added or removed
  */

  return {
    ...state,
    nodes: state.nodes.map(node => {
      if (node.id !== payload.id) {
        return node;
      }

      return {
        ...node,
        images: node.images.map((image, index) => {
          if (index !== payload.index) {
            return image;
          }

          if (!payload.url) return null;
          return {
            fileName: payload.fileName || '',
            data: payload.url,
          };
        }),
      };
    }),
  };
}

function addAttachment(state, {payload}) {
  return {
    ...state,
    nodes: state.nodes.map(node => {
      if (node.id !== payload.id) {
        return node;
      }

      return {
        ...node,
        attachments: [...node.attachments, payload.attachment],
      };
    }),
  };
}

function removeAttachment(state, {payload}) {
  return {
    ...state,
    nodes: state.nodes.map(node => {
      if (node.id !== payload.id) {
        return node;
      }

      return {
        ...node,
        attachments: node.attachments.filter(attachment => attachment.fileName !== payload.fileName),
      };
    }),
  };
}

function loadHeader(state, {header}) {
  return { ...state, header };
}

function updateHeader(state, {payload}){
  return {
    ...state,
    header: payload.params,
  };
}

const ACTION_HANDLERS = {
  [NodeListActions.ADD_NODE]:    addNode,
  [NodeListActions.UPDATE_NODE]: updateNode,
  [NodeListActions.REMOVE_NODE]: removeNode,
  [NodeListActions.SORT_NODE]: sortNode,
  [NodeListActions.SELECT_NODE]: selectNode,
  [NodeListActions.UNSELECT_NODES]: unselectNodes,
  [NodeListActions.CLEAR_NODES]: clearNodes,
  [NodeListActions.LOAD_NODES]: loadNodes,
  [NodeListActions.UPDATE_IMAGE]: updateImage,
  [NodeListActions.ADD_ATTACHMENT]: addAttachment,
  [NodeListActions.REMOVE_ATTACHMENT]: removeAttachment,
  [NodeListActions.LOAD_HEADER]: loadHeader,
  [NodeListActions.UPDATE_HEADER]: updateHeader,
};

export default createReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/reducers/nodeList.js